// extracted by mini-css-extract-plugin
export default {"wrapper":"xm-z","response":"ym-z","error":"zm-z","disabled":"Am-z","buttons":"Bm-z","feedbackQuestionSection":"Cm-z","yesNoWrapper":"Dm-z"};